export default {
  getSetor: (state) => {
    return state.setor;
  },
  getSetores: (state) => {
    return state.setores;
  },
};
